import type { DateRangeValue } from "../../../../../../components/general/DateRangeInput";

export enum InvoiceDateFieldEnum {
    INVOICE_DATE = "invoice_date",
    DUE_DATE = "due_date",
}

export interface InvoiceDateFieldOption {
    value: InvoiceDateFieldEnum;
    label: string;
}

export interface InvoiceFilterState {
    dateRange: DateRangeValue;
    dateField: InvoiceDateFieldEnum;
    relations: string[];
}

export interface InvoiceFilterAccessors<TRow> {
    getRelation: (row: TRow) => string | null;
    getDate: (row: TRow, dateField: InvoiceDateFieldEnum) => string | null;
}
